if (!customElements.get('bid-card-quick-add')) {
  customElements.define(
    'bid-card-quick-add',
    class BidCardQuickAdd extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.variantInput = this.querySelector('input.product-variant-id');
        this.submit = this.querySelector('.bid-card-qa__cart');
        this.sizeButtons = Array.from(this.querySelectorAll('.bid-card-qa__size'));
        this.priceRoot = this.closest('.card-wrapper')?.querySelector('.price');

        this.sizeButtons.forEach((button) => {
          button.addEventListener('click', () => this.selectVariant(button));
        });

        const selected = this.sizeButtons.find((button) => button.classList.contains('is-selected'));
        if (selected) this.updatePrice(selected);
      }

      selectVariant(button) {
        if (button.disabled) return;

        this.sizeButtons.forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        const variantId = button.dataset.variantId;
        const available = button.dataset.available === 'true';

        if (this.variantInput) {
          this.variantInput.value = variantId;
          this.variantInput.disabled = !available;
        }

        if (this.submit) {
          this.submit.disabled = !available;
        }

        this.updatePrice(button);
      }

      updatePrice(button) {
        if (!this.priceRoot || !button?.dataset.price) return;

        const price = button.dataset.price;
        const compareAt = button.dataset.compareAtPrice;
        const onSale = Boolean(compareAt);

        this.priceRoot.classList.toggle('price--on-sale', onSale);
        this.priceRoot.classList.toggle('price--sold-out', button.dataset.available !== 'true');

        const regularItem = this.priceRoot.querySelector('.price__regular .price-item--regular');
        const saleItem = this.priceRoot.querySelector('.price__sale .price-item--sale');
        const compareItem = this.priceRoot.querySelector('.price__sale s.price-item--regular');

        if (onSale) {
          if (compareItem) compareItem.textContent = compareAt;
          if (saleItem) saleItem.textContent = price;
          if (regularItem) regularItem.textContent = price;
        } else if (regularItem) {
          regularItem.textContent = price;
          if (saleItem) saleItem.textContent = price;
        }
      }
    }
  );
}
